import { createStyles } from '../../../../../../styles/helpers'

import { darkBlue } from '../../../../../../styles/const/colors'
import { subTable } from '../../../../../../styles/common/table'

const useStyles = createStyles({
  installationReportTable: {
    fontSize: 12
  },
  row: {
    fontSize: 12
  },
  subTable: {
    extend: subTable
  },
  subTableRow: {
    color: darkBlue,
    border: 'none !important',
    fontSize: 12
  }
})

export default useStyles
